import {StyleSheet} from 'react-native';
import {Dimensions} from 'react-native';

import {black, blackOpacity, onyx, white} from '/theme/color/on.color';
import {
  codGray,
  darkRed,
  gallery,
  mineShaft,
  pine,
  whiteSine,
  wineRed,
} from '/theme/color/secondary.color';
const screenWidth = Dimensions.get('window').width;

const margin = screenWidth > 400 ? 40 : 16;
const closeButtonHitSlopIndent = 8;

export const closeButtonHitSlop = {
  top: closeButtonHitSlopIndent,
  bottom: closeButtonHitSlopIndent,
  left: closeButtonHitSlopIndent,
  right: closeButtonHitSlopIndent,
};

export const styles = StyleSheet.create({
  modalView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: blackOpacity,
  },
  modalContent: {
    backgroundColor: white,
    paddingVertical: 16,
    paddingHorizontal: margin,
    borderRadius: 16,
    shadowColor: black,
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 15,
    elevation: 10,
  },
  topView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginTop: 10,
    paddingRight: 5,
    alignContent: 'center',
    justifyContent: 'center',
  },
  crossIcon: {
    color: onyx,
    fontSize: 20,
    alignSelf: 'flex-end',
    marginRight: -15,
  },
  modalText: {
    fontSize: 16,
    marginTop: 10,
    color: codGray,
    textAlign: 'center',
    flex: 1,
  },
  labelText: {
    fontSize: 14,
    textAlign: 'center',
    letterSpacing: -0.01,
    color: onyx,
    paddingHorizontal: 28,
    paddingVertical: 20,
  },
  emailLabel: {
    fontSize: 16,
    marginBottom: 10,
    color: mineShaft,
  },
  alertIcon: {
    color: wineRed,
    marginRight: 8,
    marginTop: 12,
    fontSize: 16,
  },
  alertView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    height: 48,
    borderColor: gallery,
    borderWidth: 1,
    padding: 10,
    backgroundColor: whiteSine,
    paddingHorizontal: 10,
    borderRadius: 6,
  },
  errorText: {
    color: darkRed,
    marginTop: 10,
  },
  resetButton: {
    padding: 10,
    backgroundColor: pine,
    borderRadius: 8,
    marginBottom: 20,
    marginTop: 20,
  },
  resetButtonText: {
    color: 'white',
    alignItems: 'center',
    textAlign: 'center',
  },
});
